import ModalPanel from '@admin/components/modal_panel'
import Infinite from '@admin/components/infinite'
import Search from '@admin/components/search'
import PropTypes from 'prop-types'
import pluralize from 'pluralize'
import Results from './results'
import React from 'react'

class List extends React.PureComponent {

  static contextTypes = {
    form: PropTypes.object
  }

  static propTypes = {
    channel: PropTypes.string,
    defaultValue: PropTypes.object,
    endpoint: PropTypes.string,
    instructions: PropTypes.any,
    program_id: PropTypes.number,
    purpose: PropTypes.string,
    onDone: PropTypes.func
  }

  state = {
    list_id: null
  }

  _handleBack = this._handleBack.bind(this)
  _handleChoose = this._handleChoose.bind(this)
  _handleDone = this._handleDone.bind(this)

  render() {
    return (
      <ModalPanel { ...this._getPanel() }>
        <div className="tofield-picker">
          <div className="tofield-picker-filter">
            <Search { ...this._getLists() } />
          </div>
          <div className="tofield-picker-main">
            <Infinite { ...this._getInfinite() } />
          </div>
        </div>
      </ModalPanel>
    )
  }

  componentDidMount() {
    const { defaultValue } = this.props
    if(!defaultValue) return
    const { list_id } = defaultValue
    this.setState({ list_id })
  }

  _getInfinite() {
    const { channel, endpoint, program_id, purpose } = this.props
    const { list_id } = this.state
    return {
      empty: {
        svg: 'clipboard_list',
        title: 't(Choose a list)',
        text: 't(Choose a list to find contacts that match)'
      },
      endpoint,
      query: {
        strategy: 'list',
        channel,
        purpose,
        program_id,
        list_id
      },
      ...!list_id ? {
        filter: null
      } : {},
      footer: ({ all, total }) => `Matching ${total} of ${pluralize('contact', all, true)}`,
      layout: Results
    }
  }

  _getLists() {
    const { defaultValue, program_id } = this.props
    return {
      defaultValue: defaultValue ? defaultValue.list_id : null,
      endpoint: `/api/admin/team/programs/${program_id}/lists`,
      prompt: 't(Find a list)',
      search: false,
      valueKey: null,
      compareKey: 'id',
      textKey: 'title',
      onChange: this._handleChoose
    }
  }

  _getPanel() {
    const { instructions } = this.props
    const { list_id } = this.state
    return {
      title: 't(Choose a List)',
      instructions,
      leftItems: [
        { svg: 'chevron_left', handler: this._handleBack }
      ],
      rightItems: list_id ? [
        { label: 't(Done)', handler: this._handleDone }
      ] : null
    }
  }

  _handleBack() {
    this.context.form.pop()
  }

  _handleChoose(list) {
    if(!list) return
    this.setState({ list_id: list.id, list_title: list.title })
  }

  _handleDone() {
    const { list_id, list_title } = this.state
    this.props.onDone({ list_id, list_title })
    this.context.form.pop()
  }

}

export default List
